import { render, staticRenderFns } from "./storage_ledger_list.vue?vue&type=template&id=6039bd6d&scoped=true"
import script from "./storage_ledger_list.vue?vue&type=script&lang=js"
export * from "./storage_ledger_list.vue?vue&type=script&lang=js"
import style0 from "./storage_ledger_list.vue?vue&type=style&index=0&id=6039bd6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6039bd6d",
  null
  
)

export default component.exports